import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ChatProvider, useChat } from '../../contexts/ChatContext';
import SessionList from '../chat/SessionList';
import ChatWindow from '../chat/ChatWindow';
import websocketManager from '../../utils/websocketManager';
import '../../assets/styles/Chat.css';

const ChatRoomContent = () => {
  const { loadSessions } = useChat();

  // 组件挂载时自动连接WebSocket并加载会话列表
  useEffect(() => {
    // 获取token
    const token = localStorage.getItem('satoken');
    if (token) {
      websocketManager.connect(token);
    }
    
    // 加载会话列表
    loadSessions();
  }, [loadSessions]);

  return (
    <div className="chat-room">
      <div className="chat-layout">
        <div className="chat-sidebar">
          <SessionList />
        </div>
        <div className="chat-main">
          <ChatWindow />
        </div>
      </div>
    </div>
  );
};

const ChatRoom = () => {
  const history = useHistory();

  // 验证用户是否已登录
  useEffect(() => {
    const token = localStorage.getItem('satoken');
    if (!token) {
      history.replace('/login');
    }
  }, [history]);

  return (
    <ChatProvider>
      <ChatRoomContent />
    </ChatProvider>
  );
};

export default ChatRoom; 